import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Spinner, Badge } from 'react-bootstrap';
import { FaHandHoldingUsd, FaStar, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { spApi } from '../../api/serviceProviders';

const ProvidersBajetiModal = ({ show, onHide, category }) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && category?.id) {
      fetchProvidersByCategory(category.id);
    }
  }, [show, category]);

  const fetchProvidersByCategory = async (categoryId) => {
    setLoading(true);
    setProviders([]);
    try {
      const response = await spApi.getProvidersByCategory(categoryId);
      let providersList = response?.data || response || [];
      if (!Array.isArray(providersList)) providersList = Object.values(providersList);
      setProviders(providersList);
    } catch (err) {
      console.error('Error fetching providers:', err);
      toast.error('Failed to load service providers');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ color: '#4169e1' }}>
          <div className="p-2 rounded-3 bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
            <FaHandHoldingUsd size={20} />
          </div>
          Watoa Huduma Za {category?.name || 'Category'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" color="primary" />
            <p className="mt-2 text-muted">Inapakia watoa huduma...</p>
          </div>
        ) : providers.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted mb-0">Hakuna watoa huduma waliopatikana katika kundi hili kwa sasa.</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover align="middle" className="border rounded-3">
              <thead className="bg-light">
                <tr>
                  <th>Jina la Mtoa Huduma</th>
                  <th>Kadirio la Nyota</th>
                  <th>Simu / Mawasiliano</th>
                  <th>Barua Pepe</th>
                  <th>Eneo / Mahali</th>
                </tr>
              </thead>
              <tbody>
                {providers.map((p) => (
                  <tr key={p.id}>
                    <td className="fw-bold text-dark">{p.business_name || p.name || 'N/A'}</td>
                    <td>
                      <Badge bg="warning" text="dark" className="d-inline-flex align-items-center gap-1">
                        <FaStar size={11} /> {p.rating || '5.0'}
                      </Badge>
                    </td>
                    <td><FaPhone size={12} className="me-1 text-muted" /> {p.phone || p.phone_number || 'N/A'}</td>
                    <td><FaEnvelope size={12} className="me-1 text-muted" /> {p.email || 'N/A'}</td>
                    <td><FaMapMarkerAlt size={12} className="me-1 text-muted" /> {p.location || p.city || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4">
        <Button variant="light" onClick={onHide} className="rounded-pill px-4 fw-medium border">
          Funga
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProvidersBajetiModal;
